export default {
  validateRonde: function (ronde) {
    let compt = 0
    let message = null
    let lastValue = 0
    let err = false
    ronde.interventions.forEach(intervention => {
      if (intervention.is_debut_ou_fin_jalon !== undefined) {
        if (intervention.is_debut_ou_fin_jalon === 0) {
          compt++
          if (lastValue === 1) {
            err = true
          }
          lastValue = 1
        } else {
          compt--
          if (lastValue === -1) {
            err = true
          }
          lastValue = -1
        }
      }
    })
    if (compt === 1) {
      message = {
        text: `Veuillez indiquer une fin pour ce nouveau jalon`,
        type: 'warning',
      }
      return message
    } else if (compt === -1 || err) {
      message = {
        text: `La répartition des jalons que vous avez défini est erronée, veuillez la corriger`,
        type: 'danger',
      }
      return message
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/ronde-validator.js